import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { Team } from "@/modules/team/entity";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import NavBarMenuItem from "@/modules/vue/components/NavBarMenuItem.vue";
import NavBarMenu from "@/modules/vue/components/NavBarMenu.vue";
import SimpleActionSheetItem from "@/modules/vue/components/SimpleActionSheetItem.vue";
import { app } from "@/di";
import SimpleActionSheet from "@/modules/vue/components/SimpleActionSheet.vue";
import GlobalResolver from "@/modules/base/services/GlobalResolver";
export default /*#__PURE__*/_defineComponent({
  __name: 'StaffMemberLayout',
  async setup(__props, {
    expose
  }) {
    let __temp, __restore;
    const route = useRoute();
    const router = useRouter();
    const team = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      team.value = await Team.createQueryBuilder('team').leftJoinAndSelect('team.staffMembers', 'staffMember').where('team.user = true').getOneOrFail();
    })), __temp = await __temp, __restore(), __temp);
    const onClickSackStaffMemberActionScreen = async () => {
      await app.get(GlobalResolver).startPromise(() => {
        router.push({
          name: 'staff.team.sack'
        });
      });
      router.push({
        name: 'staff.team.index'
      });
    };
    expose({
      refresh
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, _mergeProps(_ctx.$attrs, {
        back: ""
      }), _createSlots({
        title: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(team.value.staffSlots - team.value.staffMembers.length <= 0 ? 'text-red-600' : 'text-green-600')
        }, _toDisplayString(_ctx.$t('current_team_slots', {
          current: team.value.staffMembers.length,
          slots: team.value.staffSlots
        })), 3)]),
        submenu: _withCtx(() => [_createVNode(NavBarMenu, null, {
          default: _withCtx(() => [_createVNode(NavBarMenuItem, {
            to: {
              name: 'staff.team.index',
              params: _unref(route).params
            },
            icon: _ctx.IconEnum.PeopleCommunity20Regular,
            label: _ctx.$t('team_staff')
          }, null, 8, ["to", "icon", "label"]), _createVNode(NavBarMenuItem, {
            to: {
              name: 'staff.index',
              params: _unref(route).params
            },
            icon: _ctx.IconEnum.ArrowsHorizontal,
            label: _ctx.$t('transfer_market')
          }, null, 8, ["to", "icon", "label"])]),
          _: 1
        })]),
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 2
      }, [_ctx.$debug ? {
        name: "actionButton",
        fn: _withCtx(() => [_createVNode(SimpleActionSheet, {
          ref: "simpleActionSheet",
          "no-teleport": ""
        }, {
          actions: _withCtx(() => [_createVNode(SimpleActionSheetItem, {
            class: "italic",
            "hide-on-click": "",
            onClick: onClickSackStaffMemberActionScreen
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('show_sack_staff_member_action_screen')), 1)]),
            _: 1
          })]),
          _: 1
        }, 512)])
      } : undefined]), 1040);
    };
  }
});